/**
 * Join class names, dropping anything falsy.
 *
 * Its own module so the brand components and the UI kit can both use it
 * without importing each other - the UI kit's spinner is the product mark, and
 * the mark needs `cx`, which would otherwise be a cycle.
 */
export function cx(...parts) {
	return parts.filter(Boolean).join(" ")
}
